import React, { Fragment, useEffect } from "react";
import { Container, Row, Col, Card, CardBody, CardHeader } from "reactstrap";
import { H3, Btn, Image } from "../../AbstractElements";
import { useNavigate } from "react-router-dom";
import imgg from "../../assets/images/logo/logo.png";
import * as mutations from "../../graphql/mutations";
import { generateClient } from "aws-amplify/api";
import { limit, EMAIL_API } from "../../Config/Config";
import axios from "axios";
const client = generateClient({
  headers: {
    "x-api-key": "da2-ox6gomta4baghjuzk6hpogw25y",
  },
});

const ThankYouContain = () => {
  useEffect(() => {
    //console.log(localStorage.getItem("data"));
    //sendHelpingGuideMail();
  }, []);

  const sendHelpingGuideMail = async () => {
    try {
      const rawData = localStorage.getItem("data");
      if (!rawData) throw new Error("No localStorage data found");

      const parsed = JSON.parse(rawData);
      const recipientEmail = parsed?.Aomail;
      if (!recipientEmail) throw new Error("Aomail not found in data");

      const message = `
<html>
  <body>
    <p>Hello,</p>
    <p>Thank you for registering with <strong>Know Your Asset</strong>.</p>
    <p>We’ve prepared a <strong>Helping Guide</strong> for you.</p>
    <p>This guide contains useful information to help you get started and manage your assets efficiently.</p>
    <p>You can also find the PDF guide attached to this email.</p>
    <p>Best regards,<br/>KYA Team</p>
  </body>
</html>`;

      const pdfUrl =
        "https://kyauploadimages133428-prod.s3.ap-southeast-2.amazonaws.com/public/registerPDF/7bb4b9c0-ace5-4c2e-b4d4-339e2e96a2a8.pdf";

      const response = await fetch(pdfUrl);
      const arrayBuffer = await response.arrayBuffer();
      const base64Pdf = btoa(
        new Uint8Array(arrayBuffer).reduce(
          (data, byte) => data + String.fromCharCode(byte),
          "",
        ),
      );

      await axios.post(EMAIL_API, {
        body: JSON.stringify({
          email: recipientEmail,
          subject: "Helping Guide",
          messageBody: message,
          attachment: {
            filename: "HelpingGuide.pdf",
            content: base64Pdf,
            encoding: "base64",
          },
        }),
      });

      console.log("Helping guide email sent successfully");
    } catch (error) {
      console.error("error ", error);
    }
  };

  const navigate = useNavigate();
  const linkToRegister = () => {
    debugger;
    navigate(`${process.env.PUBLIC_URL}/login`);
  };
  return (
    <Container fluid={true} className="p-0">
      <Row>
        <Col xl="12">
          <div className="login-card">
            <Card>
              <CardHeader>
                <div className="logo-wrapper">
                  <a href="#javascript">
                    <Image
                      attrImage={{
                        className: "img-fluid",
                        src: `${imgg}`,
                        alt: "",
                      }}
                    />
                  </a>
                </div>
              </CardHeader>
              <CardBody>
                <div className="login-header text-center">
                  <H3>Thank You For Registering</H3>
                  <br></br>
                  <Btn
                    attrBtn={{
                      color: "primary",
                      onClick: () => linkToRegister(),
                    }}
                  >
                    Go To Login Page
                  </Btn>
                </div>
              </CardBody>
            </Card>
          </div>
        </Col>
      </Row>
    </Container>
  );
};
export default ThankYouContain;
